var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',[_c('v-container',[_c('h4',[_c('v-icon',[_vm._v("mdi-arrow-right-drop-circle")]),_vm._v(" "+_vm._s(_vm.$route.meta.descricao)+" ")],1),_c('v-fade-transition',{attrs:{"mode":"out-in"}},[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }